import { useDispatch, useSelector } from "react-redux";

import { TriggerClientMeetingsSync } from "./action";

function useClientSync(clientId) {
  const dispatch = useDispatch();

  const { sync } = useSelector(({ hubly }) => {
    return hubly?.data?.hub?.clientCard || {};
  });

  return {
    sync: sync,
    run: {
      meetings: (onComplete, onError) => {
        dispatch(TriggerClientMeetingsSync(clientId, onComplete, onError));
      },
    },
  };
}

export default useClientSync;
